import { ResumeLanguage } from "lib/redux/types";
import React from "react";
import { TemplateNineResumeSection, TemplateNineResumeSectionWithSubsections } from "./common";
import { View } from "@react-pdf/renderer";
import { spacing, styles } from "../ResumePDF/styles";
import { ResumePDFDescription, ResumePDFText } from "../ResumePDF/common";

const Languages = ({
  heading,
  languages,
  themeColor,
}: {
  heading: string;
  languages: ResumeLanguage[];
  themeColor: string;
}) => {
  return (
    <TemplateNineResumeSectionWithSubsections themeColor={themeColor} heading={heading}>
      <View
        wrap={false}
        style={{
          ...styles.flexRowBetween,
          flexWrap: "wrap",
        }}
      >
        {languages.map(({ language, level, descriptions }, idx) => (
          <View
            key={idx}
            style={{
              ...styles.flexCol,
              width: "40%",
              marginBottom: spacing["1"],
            }}
          >
            <View style={{ ...styles.flexRow, gap: 4 }}>
              <ResumePDFText bold={true}>• {language}</ResumePDFText>
              {level && <ResumePDFText>({level})</ResumePDFText>}
            </View>
            <View style={{ ...styles.flexRow, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription items={descriptions} />
            </View>
          </View>
        ))}
      </View>
    </TemplateNineResumeSectionWithSubsections>
  );
};

export default Languages;
